import { Asset } from './asset';

export class DuplicateAsset extends Asset {
  duplicateFileName: string;
}
